






































import CollectionSharedFunctions from '../../CollectionSharedFunctions'
import Component from 'vue-class-component'
import moment from 'moment'
import Select from '@/components/Select.vue'
import Icon from '@/components/Icon.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import DateInput from '@/components/inputs/DateInput.vue'

@Component({
  components: { TextArea, Icon, Select, DateInput },
  props: {
    newTask: {
      required: true
    }
  }
})
export default class CollectionActionPostpone extends CollectionSharedFunctions {
  dateFrom: Date = new Date()
  // dateFrom: Date = new Date(Date.now() + (24 * 60 * 60 * 1000))

  setNewTaskField (propName: string, item: any) {
    this.$set(this.$props.newTask, propName, item)
    this.$forceUpdate()
  }

  changeNewTaskDate (date: Date | string | null) {
    if (!date) {
      this.$delete(this.$props.newTask, 'taskDate')
      return
    }
    this.$set(this.$props.newTask, 'taskDate', moment(date).utc(false).set('hour', 12).set('minute', 0).add(this.user.getTimezone(), 'hours').toDate())
  }

  get validateScheduleTask () {
    return this.$props.newTask.note &&
        this.$props.newTask.assignedUser &&
        this.$props.newTask.taskDate
  }

  async scheduleCall () {
    if (!this.validateScheduleTask) {
      return
    }
    this.$emit('submit', {
      functionName: 'postponeResidentCollection',
      successMessage: 'Collection postponed',
      payloadData: {
        note: this.$props.newTask.note as string,
        taskDate: this.$props.newTask.taskDate
      }
    })
  }
}
